module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-26.7c1b33e0.png";